<div class="card" [class.readonly]="readonly" (click)="toggleDropdown($event)" *ngIf="!selectedItem">
  <div class="row">
    <span class="circle-outline"></span>
    <div class="details">
      <strong>{{'admin.toolMaintenancePlans.assignationDropdown.notAssigned' | translate}}</strong>
      <p>{{'admin.toolMaintenancePlans.assignationDropdown.recurrence' | translate}}</p>
    </div>
  </div>

  <div class="assign" *ngIf="!readonly && !dropdownVisible">{{'admin.toolMaintenancePlans.assignationDropdown.assign' | translate}}</div>
</div>

<div class="card" [class.readonly]="readonly" (click)="toggleDropdown($event)" *ngIf="selectedItem">
  <ng-container [ngTemplateOutlet]="dropdownItem"
                [ngTemplateOutletContext]="{item: selectedItem}">
  </ng-container>
</div>

<div class="options" *ngIf="dropdownVisible && !readonly && dropdownItems.length > 0">
  <div *ngFor="let item of dropdownItems" class="card" (click)="handleAssign(item)">
    <ng-container [ngTemplateOutlet]="dropdownItem"
                  [ngTemplateOutletContext]="{item: item}">
    </ng-container>
  </div>
</div>

<ng-template #dropdownItem let-item="item">
  <div class="row">
    <i [class]="item.icon"></i>
    <div class="details">
      <strong>{{item.title}}</strong>
      <p>{{item.subtitle}}</p>
    </div>
  </div>
  <div class="assign" *ngIf="item.showAssign && !readonly">
    {{'admin.toolMaintenancePlans.assignationDropdown.assign' | translate}}
  </div>
</ng-template>
